import { primaryBlue, primaryGray, white } from "../colors";
import * as React from "react";

 const Circle = (props) => {
  const paddedNumber = (props.number).toString().padStart(2, '0');
  return (
    <div>
      <div
        style={{
          display:"flex",
          justifyContent:"center",
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          backgroundColor: props.completed ? primaryBlue : white,
          border: props.active ? "2px solid #2A7CED" : (props.completed ? `2px solid ${primaryBlue}` : "0.25px solid #8F8F8F"),
          textAlign: "center",
          alignItems:"center",
          boxShadow: "0px 4px 8px #0000001F",
        }}
      >
        <h5 style={{
          fontSize: "16px",
          color: props.active ? primaryBlue : (props.completed ? white : primaryGray)
        }}>
          {paddedNumber}
        </h5>
      </div>
    </div>
  );
};
export default Circle;

